import { Route } from "@angular/router";
import { DocumentLayout } from "../pages/document/layout/document.layout";
import { DocumentBoxFormGuard } from "../pages/document/pages/document-box/document-box-form/document-box-form.guard";
import { fixDocumentFormGuard } from "../pages/document/pages/fix-document/fix-document-form/fix-document-form.guard";
import { preDocumentFormGuard } from "../pages/document/pages/pre-document/pre-document-form/pre-document-form.guard";

export const documentRoutes: Route[] = [
    {
        path: "document",
        component: DocumentLayout,
        children: [
            { path: "", redirectTo: "document-box", pathMatch: "full" },
            {
                path: "document-box",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("../pages/document/pages/document-box/document-box.page"),
                    },
                    {
                        canDeactivate: [DocumentBoxFormGuard],
                        path: "form",
                        loadComponent: () =>
                            import("../pages/document/pages/document-box/document-box-form/document-box-form.page"),
                    },
                    {
                        path: "fix",
                        children: [
                            {
                                path: "form",
                                canDeactivate: [fixDocumentFormGuard],
                                loadComponent: () =>
                                    import("../pages/document/pages/fix-document/fix-document-form/fix-document-form"),
                            },
                            {
                                path: ":documentId",
                                loadComponent: () =>
                                    import("../pages/document/pages/fix-document/fix-document-detail/fix-document-detail"),
                            },
                        ],
                    },
                    {
                        path: "pre",
                        children: [
                            {
                                path: "form",
                                canDeactivate: [preDocumentFormGuard],
                                loadComponent: () =>
                                    import("../pages/document/pages/pre-document/pre-document-form/pre-document-form"),
                            },
                            {
                                path: ":documentId",
                                loadComponent: () =>
                                    import("../pages/document/pages/pre-document/pre-document-detail/pre-document-detail"),
                            },
                        ],
                    },
                    {
                        path: "etc",
                        children: [
                            {
                                path: ":documentId/form",
                                canDeactivate: [fixDocumentFormGuard],
                                loadComponent: () =>
                                    import("../pages/document/pages/fix-document/fix-document-form/fix-document-form"),
                            },
                            {
                                path: ":documentId",
                                loadComponent: () =>
                                    import("../pages/document/pages/fix-document/fix-document-detail/fix-document-detail"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "schedule-log",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("../pages/document/pages/schedule-log/schedule-log.page"),
                    },
                ],
            },
        ],
    },
];
